// extracted by mini-css-extract-plugin
export default {"container":"RelatedConcepts__container___eicJK","list":"RelatedConcepts__list___vwUHQ","viewList":"RelatedConcepts__viewList___hlSAM"};